import React from 'react';
// import styles from './StaffMembers.module.scss';
import StaffMembersTable from "../../../components/StaffMembersTable/StaffMembersTable";
import StaffMembersComparisonGraph from "../../../components/StaffMembersComparisonGraph/StaffMembersComparisonGraph";


const ClinicStaffMembers = (props) => {
    return(
        <div>
            <StaffMembersTable userType={2} />
            <StaffMembersComparisonGraph />
        </div>
    )
}


export default ClinicStaffMembers;
